import { hot } from 'react-hot-loader';
import LinkExternal from '../components/Link/LinkExternal';
import TelegramIcon from './SvgRobo/TelegramIcon';
import LinkedinIcon from './SvgRobo/LinkedinIcon';
import TwitterIcon from './SvgRobo/TwitterIcon';
import InstagramIcon from './SvgRobo/InstagramIcon';
import ImdbIcon from './SvgRobo/ImdbIcon';
import './Team.scss';



function Team({
  name,
  imdb, twitter, instagram, telegram, linkedin,
  poster, posterhd,
  photo, photohd,
  horizontal
}) {
  if (poster && photo)
    return (
      <div className="team">
        <div className="team-card">
          <div className="team-card-inner">
            <div className="team-card__state">
              <img src={poster} alt="" title="" />
            </div>
            <div className="team-card__hover">
              <img src={photo} alt="" title="" />
            </div>
          </div>
        </div>

        <div className="team-bottom">
          <div className="team-name">{name}</div>
          <div className={horizontal === "1" ? "team-info team-info__horizontal" : "team-info"}>
            {telegram && <LinkExternal href={telegram}><TelegramIcon /></LinkExternal>}
            {linkedin && <LinkExternal href={linkedin}><LinkedinIcon /></LinkExternal>}
            {twitter && <LinkExternal href={twitter}><TwitterIcon /></LinkExternal>}
            {instagram && <LinkExternal href={instagram}><InstagramIcon /></LinkExternal>}
            {imdb && <LinkExternal href={imdb}><ImdbIcon /></LinkExternal>}
          </div>
        </div>
      </div>
    );

  return (null);
};

export default hot(module)(Team);
